/* eslint-disable react-hooks-ssr/react-hooks-global-ssr */

/* eslint-disable import/prefer-default-export */
export var withAnimation = function withAnimation() {
  var tests = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function () {};
  describe('With animation mocked', function () {
    beforeEach(function () {
      jest.spyOn(window, 'requestAnimationFrame').mockImplementation(function (cb) {
        return cb();
      });
    });
    afterEach(function () {
      window.requestAnimationFrame.mockRestore();
    });
    tests();
  });
};
export var attachGlobalDependencyMocks = function attachGlobalDependencyMocks() {
  // Mock popperjs - used with popovers
  jest.mock('@popperjs/core', function () {
    return {
      createPopper: jest.fn(function () {
        return {
          destroy: jest.fn(),
          update: jest.fn()
        };
      })
    };
  });
};